import axios from "axios";
import router from '../router/index'
//引入


//请求根路径 mock路径
// axios.defaults.baseURL = 'http://127.0.0.1:4523/m1/1179224-0-default'
axios.defaults.baseURL = '/api'
axios.defaults.headers.post['Content-Type'] = 'application/json';
// 请求拦截
axios.interceptors.request.use(config => {
  // console.log(config)
  //拦截所有请求，添加登陆用户的token
  if (window.localStorage.getItem('x-token')) {
    config.headers['x-token'] = window.localStorage.getItem('x-token');
  }
  return config
})


// 响应拦截
//后台用户登陆信息校验不成功就跳转到登录页面
axios.interceptors.response.use(response => {
  // console.log("返回的response")
  // console.log(response.data)
  if (response.data.code === 401) {
    /*没有token*/
    console.log("返回的401", 'token过期')
    router.push('/login').catch(() => console.log('401token过期'))
    // 中断Promise链
    return new Promise(() => {
    })
  }
  return response
// eslint-disable-next-line no-unused-vars
}, error => {

  //token过期 401跳转登录
  if (error.response.status === 401) {
    router.push('/login').catch(() => console.log('401token过期'))
  }
  //统一异常处理
  console.log("响应拦截器失败的响应", error)
  // 中断Promise链
  return new Promise(() => {
  })
})

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise(resolve => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
  });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise(resolve => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    })
  });
}

/**
 * patch
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
export function patch(url, params) {
  return new Promise(resolve => {
    axios.patch(url, params).then(res => {
      resolve(res.data);
    })
  });
}

/**
 * patch
 * @param url
 * @param params
 * @returns {Promise<unknown>}
 */
export function put(url, params) {
  return new Promise(resolve => {
    axios.put(url, params).then(res => {
      resolve(res.data);
    })
  });
}


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function download(url, params) {
  return new Promise(resolve => {
    axios.get(url, {
      params: params
      , responseType: 'blob'
    }).then(res => {
      const blob = res.data

      const [[key, filename]] = res.headers['content-disposition'].split(';')
        .map(val => val.trim())
        .filter(val => val.startsWith('filename'))
        .map(val => val.split('='))
      const downloadFilename = decodeURIComponent(filename)
      console.log(['filename', downloadFilename])
      const a = document.createElement('a')
      // blob.type = 'application/octet-stream'
      // 创键临时url对象
      const url = URL.createObjectURL(blob)
      a.href = url
      a.download = downloadFilename
      a.click()
      // 释放之前创建的URL对象
      URL.revokeObjectURL(url)

      resolve();
    })
  });
}



// WEBPACK FOOTER //
// ./src/api/axios.js